import axios from 'axios';

const restURL = process.env.REACT_APP_API_ENDPOINT;

export function getValueSets() {
  return axios.get(`${restURL}/valueSets`).then((response) => {
    return response.data;
  });
}
